import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UtilsService } from "src/app/services/utils";
import { ReceiptRow } from "src/app/types/receiptrow";

@Component({
  selector: "app-guest-product",
  templateUrl: "./guest-product.component.html",
  styleUrls: ["./guest-product.component.scss"],
})
export class GuestProductComponent implements OnInit {

  @Input() product: ReceiptRow;
  @Output() productClicked = new EventEmitter();

  constructor(private utils: UtilsService) { }

  ngOnInit() {}

  doSellProduct() {
    this.productClicked.emit();
  }

}
